import { render } from "./DashboardUpcomingEvents.vue?vue&type=template&id=379b1253&scoped=true"
import script from "./DashboardUpcomingEvents.vue?vue&type=script&lang=js"
export * from "./DashboardUpcomingEvents.vue?vue&type=script&lang=js"

import "./DashboardUpcomingEvents.vue?vue&type=style&index=0&id=379b1253&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379b1253"]])

export default __exports__